require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./visiter-le-campus-1-0-3.json") })
        }
      }, "path---visiter-le-campus-1-0-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---visiter-le-campus-1-0-3!./.cache/json/visiter-le-campus-1-0-3.json
// module id = 608
// module chunks = 231608221292675